import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Callback from './callback';
import CatalogoInstitucion from './catalogo-institucion';
import Cliente from './cliente';
import Estatus from './estatus';
import Mensaje from './mensaje';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        <Route path="/cliente/*" element={<Cliente />} />
        <Route path="/mensaje/*" element={<Mensaje />} />
        <Route path="/callback/*" element={<Callback />} />
        <Route path="/catalogo-institucion/*" element={<CatalogoInstitucion />} />
        <Route path="/estatus/*" element={<Estatus />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
